import React, { useEffect, useState } from "react";
import { Navbar, Nav, Container, Form, FormControl, Button, NavDropdown, ListGroup } from "react-bootstrap";
import { FaSearch, FaUserCircle } from "react-icons/fa";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { searchMulti } from "../../Api/Moviesapi";
import { useApp } from "../../context/AppContext";

const Navigation = () => {
  const navigate = useNavigate();
  const { user, signOut } = useApp();
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const query = searchTerm.trim();
    if (query.length < 2) { setSuggestions([]); return undefined; }
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      try {
        const items = await searchMulti(query);
        if (!controller.signal.aborted) setSuggestions(items.filter((item) => ["movie", "tv"].includes(item.media_type)).slice(0, 6));
      } catch { if (!controller.signal.aborted) setSuggestions([]); }
    }, 300);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [searchTerm]);

  const clearSearch = () => { setSearchTerm(""); setSuggestions([]); };
  const submit = (event) => {
    event.preventDefault();
    if (searchTerm.trim()) { navigate(`/search/${encodeURIComponent(searchTerm.trim())}`); clearSearch(); }
  };

  return <Navbar bg="dark" variant="dark" expand="lg" sticky="top" className="px-3">
    <Container fluid>
      <Navbar.Brand as={Link} to="/">ZeZo</Navbar.Brand>
      <Navbar.Toggle aria-controls="navbar-nav" />
      <Navbar.Collapse id="navbar-nav">
        <Nav className="me-auto">
          <Nav.Link as={NavLink} to="/">Home</Nav.Link>
          <Nav.Link as={NavLink} to="/tvshows">TV Shows</Nav.Link>
          <Nav.Link as={NavLink} to="/movies">Movies</Nav.Link>
          <Nav.Link as={NavLink} to="/mylist">My List</Nav.Link>
        </Nav>
        <Form className="d-flex me-3 position-relative search-form" onSubmit={submit}>
          <FormControl type="search" placeholder="Search movies or TV shows" aria-label="Search" value={searchTerm} onChange={(event) => setSearchTerm(event.target.value)} autoComplete="off" />
          <Button variant="outline-light" type="submit" aria-label="Submit search"><FaSearch /></Button>
          {suggestions.length > 0 && <ListGroup className="search-suggestions">
            {suggestions.map((item) => <ListGroup.Item key={`${item.media_type}-${item.id}`} action onClick={() => { navigate(`/detail/${item.media_type}/${item.id}`); clearSearch(); }}>{item.title || item.name} <small>({item.media_type})</small></ListGroup.Item>)}
          </ListGroup>}
        </Form>
        {user ? <NavDropdown title={<FaUserCircle size={24} />} id="user-menu" align="end" menuVariant="dark">
          <NavDropdown.Item onClick={() => navigate("/profile")}>Profile</NavDropdown.Item>
          <NavDropdown.Divider /><NavDropdown.Item onClick={() => { signOut(); navigate("/"); }}>Logout</NavDropdown.Item>
        </NavDropdown> : <Nav><Nav.Link as={NavLink} to="/login">Login</Nav.Link></Nav>}
      </Navbar.Collapse>
    </Container>
  </Navbar>;
};
export default Navigation;
